import { useState } from 'react';
import { StyledButtonMergeCancel } from '../styles';
import Swal from 'sweetalert2';
import { blockchainService } from '../../../../../services/blockchainService';

export const CancelarMerge = ({
  projectId,
  modeloDocumentId,
  topicDocumentId,
  recarregaMerge,
  disabled = false
}) => {
  const [loading, setLoading] = useState(false);
  const token = sessionStorage.getItem('Authorization');
  const headers = { Authorization: `Bearer ${token}` };

  const cancelarMerge = async (motivo, senha) => {
  setLoading(true);
  try {
    const response = await blockchainService.cancelMerge(
      projectId,
      modeloDocumentId,
      topicDocumentId,
      motivo,
      senha,
      headers
    );

    Swal.fire('Sucesso', response.message, 'success');

    if (recarregaMerge) recarregaMerge();
  } catch (error) {
    const msg = error.response?.data?.error || 'Erro ao cancelar merge.';
    Swal.fire('Erro', msg, 'error');
  } finally {
    setLoading(false);
  }
};

  const handleClick = async () => {
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: 'Cancelar Merge',
      html: `
        <div>
          <label for="motivo">Motivo do Cancelamento:</label>
          <textarea id="swal-motivo" class="swal2-textarea" placeholder="Digite o motivo..."></textarea>
        </div>
        <div style="margin-top: 10px;">
          <label for="senha">Senha do Usuário:</label>
          <input type="password" id="swal-senha" class="swal2-input" placeholder="Digite sua senha" />
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar Cancelamento',
      cancelButtonText: 'Voltar',
      preConfirm: () => {
        const motivo = document.getElementById('swal-motivo').value;
        const senha = document.getElementById('swal-senha').value;
        if (!motivo || !senha) {
          Swal.showValidationMessage('Preencha motivo e senha!');
          return false;
        }
        return { motivo, senha };
      }
    });

    if (isConfirmed && formValues) {
      cancelarMerge(formValues.motivo, formValues.senha);
    }
  };

  return (
    <div style={{ float: 'left', marginLeft: '5px' }}>
      <StyledButtonMergeCancel
        onClick={handleClick}
        disabled={loading || disabled}
        style={{
          cursor: disabled || loading ? 'not-allowed' : 'pointer',
          backgroundColor: disabled ? 'var(--border-default)' : '#FFA07A',
          color: disabled ? 'var(--text-muted)' : 'var(--text-on-accent)',
        }}
      >
        {loading ? 'Cancelando...' : 'Cancelar'}
      </StyledButtonMergeCancel>
    </div>
  );
};
